module.exports = __webpack_public_path__ + "f3145b8c65ae6a18b93a216ca54c1172.pdf";